import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "counter"]
  static values = { max: Number }

  connect() {
    this.updateCounter()
  }

  updateCounter() {
    const length = this.inputTarget.value.length
    this.counterTarget.textContent = `${length}/${this.maxValue}`
    
    // Change color based on character count
    if (length > this.maxValue * 0.9) {
      this.counterTarget.classList.remove("text-gray-400", "text-yellow-500")
      this.counterTarget.classList.add("text-red-500")
    } else if (length > this.maxValue * 0.75) {
      this.counterTarget.classList.remove("text-gray-400", "text-red-500")
      this.counterTarget.classList.add("text-yellow-500")
    } else {
      this.counterTarget.classList.remove("text-red-500", "text-yellow-500")
      this.counterTarget.classList.add("text-gray-400")
    }
  }
}